( function ( $ ) {
  $( document ).ready( function ( $ ) {
    if ( $( "html" ).hasClass( "is-animating" ) ) {
      $( "html" ).removeClass( "is-animating" );
      setTimeout( function () {

      }, 150 );
    }
    // Your site's jQuery goes inside this .ready() function.

    ​
    /*****************************************************************
      Touch fix for devices to mimick hover effects
    ******************************************************************/
    $( "*" )
      .on( "touchstart", function () {
        $( this ).trigger( "hover" );
      } )
      .on( "touchend", function () {
        $( this ).trigger( "hover" );
      } );​
    /*****************************************************************
      Opening & closing the various navigation menu buttons
    ******************************************************************/
    $( "#menu-btn" ).click( function ( event ) {
      if ( $( "body" ).hasClass( "menu-open" ) ) {
        $( this ).removeClass( "active" );
        $( "body" ).removeClass( "menu-open" );
      } else {
        $( this ).addClass( "active" );
        $( "body" ).addClass( "menu-open" );​
      }
    } );​

    // Toggle Mobile Sub Menus if has Children
    $( window ).on( 'load', function () {
      if ( window.outerWidth < 950 ) {
        var $subLink = $( ".collapse > a" ),
          $submenuLink = $( '.collapse .sub-menu a' );
        $subLink.attr( "href", 'javascript:void(0)' );

        $subLink.on( 'click', function ( e ) {
          e.preventDefault();
          $( this ).parent().toggleClass( 'sub-menu-open' );
          $( this ).next( '.sub-menu' ).slideToggle( 200 );
        } );

        $submenuLink.on( 'click', function ( e ) {
          $( '#menu-btn' ).removeClass( 'active' );
        } );

      }
    } );

    $( '.search-btn-desktop' ).click( function ( event ) {
      if ( $( "body" ).hasClass( "search-open" ) ) {
        $( this ).removeClass( "active" );
        $( "body" ).removeClass( "search-open" );
      } else {
        $( this ).addClass( "active" );
        $( "body" ).addClass( "search-open" );​
      }
    } );
    /*****************************************************************
      END clicking of various navigation menu buttons
    ******************************************************************/

  } ); // end .ready()
} )( jQuery );​
// Anything above this line runs only one time on first page load

theScrollOutArgs = {
  // once: true,
  // cssProps: {
  //     visibleY: true
  // }
};

jQuery( document ).on( "page.ready", function () {
  // Anything below this line runs after every ajax page load
  $ = jQuery;
  var inHeight = window.innerHeight / 100;

  var headerHeight = $( '.menu-container' ).outerHeight();
  $( 'body' ).css( { 'margin-top': headerHeight + 'px' } );
  $( window ).scroll( function () {
    if ( $( window ).scrollTop() > headerHeight ) {
      $( 'body' ).addClass( 'fixed-show' );
    } else {
      $( 'body' ).removeClass( 'fixed-show' );
    }
  } );

  Splitting();
  ScrollOut( theScrollOutArgs ).index();
  ParallaxScroll.init();
  document.documentElement.style.setProperty( "--vh", inHeight + "px" );
  $( "#movetic" ).replaceWith(
    '<a href="http://themovetic.com/" target="_blank">Site by <span>Movetic</span></a>'
  );​
  /*****************************************************************
      Cookies for Privacy Policy
    ******************************************************************/
  var Cookie = {
    Create: function ( name, value, days ) {
      var expires = "";

      if ( days ) {
        var date = new Date();
        date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
        expires = "; expires=" + date.toGMTString();
      }

      document.cookie = name + "=" + value + expires + "; path=/";
    },
    Read: function ( name ) {
      var nameEQ = name + "=";
      var ca = document.cookie.split( ";" );

      for ( var i = 0; i < ca.length; i++ ) {
        var c = ca[ i ];
        while ( c.charAt( 0 ) == " " ) c = c.substring( 1, c.length );
        if ( c.indexOf( nameEQ ) === 0 ) return c.substring( nameEQ.length, c.length );
      }
      return null;
    },
    Erase: function ( name ) {
      Cookie.create( name, "", -1 );
    }
  };
  var cookiePolicyAgree = ( Cookie.Read( 'policyagreed' ) == 1 );
  if ( !cookiePolicyAgree ) {

    $( '#cookies-notice button' ).click( function ( event ) {
      $( '#cookies-notice' ).css( 'display', 'none' );

      Cookie.Create( 'policyagreed', '1', 7 );
    } );
  } else {
    // User has already told us they are of age
    $( '#cookies-notice' ).css( 'display', 'none' );
  }
  /*****************************************************************
    END Cookies for Age Gate
  ******************************************************************/

  /*****************************************************************
    For when we do a img src="example.svg" SVG use instead of the 
    <svg> html markup
  ******************************************************************/
  ​
  $( "img.svg" ).each( function () {
    var $img = $( this );
    var imgID = $img.attr( "id" );
    var imgClass = $img.attr( "class" );
    var imgURL = $img.attr( "src" );
    var dataFill = $img.attr( 'data-fill-color' );
    var dataStroke = $img.attr( 'data-stroke-color' );
    $.get(
      imgURL,
      function ( data ) {
        // Get the SVG tag, ignore the rest
        var $svg = $( data ).find( "svg" ),
          $svgElements = $( data ).find( "svg *" );​
        // Add replaced image's ID to the new SVG
        if ( typeof imgID !== "undefined" ) {
          $svg = $svg.attr( "id", imgID );
        }
        // Add replaced image's classes to the new SVG
        if ( typeof imgClass !== "undefined" ) {
          $svg = $svg.attr( "class", imgClass + " replaced-svg" );
        }​

        if ( $img.parent( '.svg-egg' ).length ) {
          // console.log('Easter Egg.');
          $svgElements = $svgElements.removeAttr( "stroke" );
        }
        // Add Fill color of SVG
        if ( typeof dataFill !== "undefined" ) {
          $svg = $svg.attr( "fill", dataFill );
        }​

        // Add Stroke color of SVG
        if ( typeof dataStroke !== "undefined" ) {
          $svg = $svg.attr( "stroke", dataStroke );
        }​

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr( "xmlns:a" );​

        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if (
          !$svg.attr( "viewBox" ) &&
          $svg.attr( "height" ) &&
          $svg.attr( "width" )
        ) {
          $svg.attr(
            "viewBox",
            "0 0 " + $svg.attr( "height" ) + " " + $svg.attr( "width" )
          );
        }​
        // Replace image with new SVG
        $img.replaceWith( $svg );
      },
      "xml"
    );
  } );​

  /*****************************************************************
      Animation Library / Area.
​
      Scroll Magic + GSAP
    ******************************************************************/
  ​
  // init scroll magic
  var smcontroller = new ScrollMagic.Controller();​
  $( ".fade-in-up" ).each( function () {
    var me = $( this );
    var showFromBot = new ScrollMagic.Scene( {
        triggerElement: this,
        triggerHook: .95
      } )
      .on( "start", function ( event ) {
        $( me ).addClass( "show" );
      } )
      //.addIndicators()
      .addTo( smcontroller );
  } );​
  $( ".fade-in-left" ).each( function () {
    var me = $( this );
    var showFromLeft = new ScrollMagic.Scene( {
        triggerElement: this,
        triggerHook: .95
      } )
      .on( "start", function ( event ) {
        $( me ).addClass( "show" );
      } )
      //.addIndicators()
      .addTo( smcontroller );
  } );​
  $( ".fade-in-right" ).each( function () {
    var me = $( this );
    var showFromRight = new ScrollMagic.Scene( {
        triggerElement: this,
        triggerHook: .95
      } )
      .on( "start", function ( event ) {
        $( me ).addClass( "show" );
      } )
      //.addIndicators()
      .addTo( smcontroller );
  } );
  var smcontroller = new ScrollMagic.Controller();​
  $( ".line-reveal" ).each( function () {
    var me = $( this );
    var lineReveal = new ScrollMagic.Scene( {
        triggerElement: this,
        triggerHook: 1
      } )
      .on( "start", function ( event ) {
        $( me ).addClass( "show" );
      } )
      //.addIndicators()
      .addTo( smcontroller );
  } );​​
  /*$( ".slide-reveal-right" ).each( function () {
    var me = $( this );
    var slideRevealRight = new ScrollMagic.Scene( {
        triggerElement: this,
        triggerHook: .8
      } )
      .on( "start", function ( event ) {
        $( me ).addClass( "reveal" );
      } )
      //.addIndicators()
      .addTo( smcontroller );
  } );​
  $( ".slide-reveal-left" ).each( function () {
    var me = $( this );
    var slideRevealLeft = new ScrollMagic.Scene( {
        triggerElement: this,
        triggerHook: .8
      } )
      .on( "start", function ( event ) {
        $( me ).addClass( "reveal" );
      } )
      //.addIndicators()
      .addTo( smcontroller );
  } );​*/
  $( ".scale-enter" ).each( function () {
    var me = $( this );
    var slideRevealLeft = new ScrollMagic.Scene( {
        triggerElement: this,
        triggerHook: 1
      } )
      .on( "start", function ( event ) {
        $( me ).addClass( "unscale" );
      } )
      //.addIndicators()
      .addTo( smcontroller );
  } );​

  /*****************************************************************
    Basic AutoWidth Slider
  ******************************************************************/
  setTimeout( function () {
    $( ".photo-slider-section .owl-carousel" ).each( function () {
      var $slider = $( this );
      $slider.owlCarousel( {
        autoplay: false,
        nav: true,
        items: 4,
        singleItem: false,
        rewind: false,
        slideBy: "page",
        dots: true,
        margin: 20,
        loop: true,
        autoWidth: true,
        onInitialized: fixAutowidth,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" width="103.324" height="51.143" viewBox="0 0 103.324 51.143"><g transform="translate(-6 -5.379)"><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M107.824 18H7.5" transform="translate(0 12.95)"/><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M30.95 54.4L7.5 30.95 30.95 7.5"/></g></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" width="103.324" height="51.143" viewBox="0 0 103.324 51.143"><g transform="rotate(180 50.912 24.51)"><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M100.324 0H0" transform="translate(0 23.45)"/><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M23.45 46.9L0 23.45 23.45 0"/></g></svg>'
        ],
        responsive: {
          0: {
            items: 1,
            margin: 10,
            autoWidth: true,
            center: true
          },
          768: {
            items: 2,
            margin: 10,
            autoWidth: true
          },
          1200: {
            items: 4,
            autoWidth: true
          }
        }
      } );
    } );

    function fixAutowidth( event ) {
      var $theSlider = event.target,
        $theStage = $( $theSlider )
        .children()
        .children( ".owl-stage" ),
        stageWidth = $( $theStage ).width() + event.item.count;

      setTimeout( function () {
        $( $theStage ).css( "width", stageWidth + "px" );
      }, 150 );
    }
  }, 150 );
  /*****************************************************************
      END Basic AutoWidth Slider
    ******************************************************************/
} );